export default "__VITE_ASSET__9DP0coeT__"